var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaoTomeAndPrincipe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0107C24.8366 32.0107 32 24.8473 32 16.0107C32 7.17419 24.8366 0.0107422 16 0.0107422C7.16344 0.0107422 0 7.17419 0 16.0107C0 24.8473 7.16344 32.0107 16 32.0107Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73884 10.4456H31.0045C28.7438 4.35274 22.8791 0.0107422 15.9997 0.0107422C11.5813 0.0107422 7.58177 1.80193 4.68652 4.69755L9.73884 10.4456Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73884 21.576H31.0045C28.7438 27.6688 22.8791 32.0108 15.9997 32.0108C11.5813 32.0108 7.58177 30.2196 4.68652 27.324L9.73884 21.576Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68677 4.69702C-1.56161 10.9454 -1.56161 21.0761 4.68677 27.3245C7.26883 24.7425 9.75214 22.2591 16.0005 16.0108L4.68677 4.69702Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3174 13.2281L21.0081 15.3538H23.2432L21.435 16.6676L22.1257 18.7933L20.3174 17.4795L18.5092 18.7933L19.1998 16.6676L17.3916 15.3538H19.6267L20.3174 13.2281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2733 13.2281L27.9639 15.3538H30.199L28.3909 16.6676L29.0815 18.7933L27.2733 17.4795L25.465 18.7933L26.1557 16.6676L24.3474 15.3538H26.5825L27.2733 13.2281Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0107422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaoTomeAndPrincipe);
export default __webpack_public_path__ + "static/media/sao-tome-and-principe.0e3ead27.svg";
export { ForwardRef as ReactComponent };